<script setup>
/**
 * HeicImg — drop-in <img> replacement that handles HEIC/HEIF src URLs.
 * On browsers that don't support HEIC natively (Chrome, Firefox), it fetches
 * the image, converts it to JPEG via heic2any, and renders the result.
 * Safari handles HEIC natively so conversion is skipped there.
 */
import { ref, watch, onUnmounted } from "vue";
import { heicSrcToJpeg } from "@/lib/heic";

const props = defineProps({
  src: { type: String, default: "" },
  alt: { type: String, default: "" },
});

const displaySrc = ref(props.src);
let objectUrl = null;

async function resolve(src) {
  // Clean up any previous object URL
  if (objectUrl) { URL.revokeObjectURL(objectUrl); objectUrl = null; }
  if (!src) { displaySrc.value = ""; return; }

  const resolved = await heicSrcToJpeg(src);
  if (resolved !== src) objectUrl = resolved; // it's a blob URL we own
  displaySrc.value = resolved;
}

watch(() => props.src, resolve, { immediate: true });
onUnmounted(() => { if (objectUrl) URL.revokeObjectURL(objectUrl); });
</script>

<template>
  <img v-bind="$attrs" :src="displaySrc" :alt="alt" />
</template>
